<template>
<div>
  <h1 class="About-FirstTitle" style="background-color: rgb(230,196,98);">{{Link.Title}}</h1>
  <div class="About">
    <p class="Link" title="晨曦啊"><a href="https://cx-a.com" target='_blank'><img class="FriendImage" src="https://cx-a.com/zy/txx.png"></a><b style="font-weight:bolder;"></b><a href="https://cx-a.com" target='_blank'>晨曦啊</a></p>
    <p class="Link" title="ncc的个人网站"><a href="https://www.zqcnc.cn/" target='_blank'><img class="FriendImage" src="https://secure.gravatar.com/avatar/e53fa73039fa60c5862480ae2192d215?s=50&amp;r=G&amp;d="></a><b style="font-weight:bolder;"></b><a href="https://www.zqcnc.cn/" target='_blank'>ncc的个人网站</a></p>
    <p class="Link" title="继续踏上旅途，在没有你的春天……" target='_blank'><a href="https://www.dreamwings.cn"><img class="FriendImage" src="https://www.dreamwings.cn/wp-content/uploads/2018/06/806e52a2e2b9ff4bd2c23140df75cc1f.jpeg"></a><b style="font-weight:bolder;"></b><a href="https://www.dreamwings.cn" target='_blank'>千千</a></p>
    <p class="Link" title="靖待" target='_blank'><a href="https://hubojing.github.io/"><img class="FriendImage" src="https://hubojing.github.io/img/avatar.jpg"></a><b style="font-weight:bolder;"></b><a href="https://hubojing.github.io/" target='_blank'>靖待</a></p>
    <p class="Link" title="肥柴之家"><a href='https://www.bytecho.net' target='_blank'><img class="FriendImage" src='https://images.bytecho.net/images/2020/08/09/56972305f50a7a64e63da34751242f6b.png'></a><b style="font-weight:bolder;"></b><a href='https://www.bytecho.net' target='_blank'>肥柴之家</a></p>
    <p class="Link" title="甜甜哒~萌萌哒~ε๑⍥๑з"><a href='http://www.sweetsmoe.com/' target='_blank'><img class="FriendImage" src='http://sweetsmoe.cn-sh2.ufileos.com/blog.gif' alt='甜甜哒~萌萌哒~ε๑⍥๑з'></a><b style="font-weight:bolder;"></b><a href='http://www.sweetsmoe.com/' target='_blank'>甜小萌</a></p>
    <p class="Link" title="OI blog | kaispace"><a href='https://kaispace.com.cn/' target='_blank'><img class="FriendImage" src='http://47.102.221.29/usr/themes/material/head.jpg'></a><b style="font-weight:bolder;"></b><a href='https://kaispace.com.cn/' target='_blank'>OI blog | kaispace</a></p>







    <p v-html="Link.Content" class="About-Content"></p>
  </div>
</div>
</template>

<script>
export default {
  name: "Link",
  computed: {
    Link: function () {
      return this.$store.state.LANGUAGECONTENT.Link;
    }
  }
}
</script>

<style src="../assets/StyleSheet/About.css" scoped>

</style>